import { Button, type ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { WhatsAppIcon } from './WhatsAppIcon';

interface WhatsAppSupportTriggerProps extends ButtonProps {
  showLabel?: boolean;
}

export function WhatsAppSupportTrigger({
  className,
  showLabel = false,
  children,
  ...props
}: WhatsAppSupportTriggerProps) {
  return (
    <Button
      type="button"
      variant={showLabel ? 'outline' : 'ghost'}
      size={showLabel ? 'sm' : 'icon'}
      className={cn(
        'border-emerald-500/30 text-emerald-600 transition-colors hover:border-emerald-500/50 hover:bg-emerald-500/10 hover:text-emerald-700 dark:text-emerald-400 dark:hover:text-emerald-300',
        className
      )}
      {...props}
    >
      <WhatsAppIcon className="h-4 w-4" />
      {showLabel ? <span>{children || 'Support'}</span> : <span className="sr-only">Open WhatsApp support chat</span>}
    </Button>
  );
}
